import React from 'react';

export const TranslateContext = React.createContext()